import { CreateActionsDropdown } from './CreateActionsDropdown';
import { listSection } from './workoutsListPage.css';
import { WorkoutsTabs } from './WorkoutsTabs';
import { TitledPage } from '@client/new/components/Misc';

export function WorkoutsPage({ isLoading, creator, children }) {
  const title = 'Workouts';

  return (
    <TitledPage
      title={title}
      rightContent={
        <CreateActionsDropdown
          influencerId={creator.id}
          selectedProgramId={null}
        />
      }
    >
      <div className={listSection}>
        <WorkoutsTabs creatorId={creator.id} />
        {isLoading && <div>Loading...</div>}
        {!isLoading && children}
      </div>
    </TitledPage>
  );
}
